import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Image,
  Card,
  message,
  Spin,
  Carousel,
  Menu,
} from "../../../components/common/utils/antd-imports/AntdImports.js";
import "./BuyerDashboard.css";
import helpIcon from "../../../assests/helpIcon.svg";
import slantArrowIcon from "../../../assests/slant-arrow.svg";
import InsertionOrderIcon from "../../../assests/instertion-order-campaigns-icon.svg";
import ScheduledOrderIcon from "../../../assests/scheduled-campaigns-icon.svg";
import ActiveCampaignsIcon from "../../../assests/active-campaigns-icon.svg";
import CompletedCampaignsIcon from "../../../assests/completed-campaigns-icon.svg";
import TotalCampaignsIcon from "../../../assests/total-campaigns-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { buyerDashboardCampaignsCount } from "../../../store/thunks/buyer-thunks/BuyerThunks";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import "../../../../src/main.css";
import ShareCampaign from "../../../components/modal/share-campaign-modal/ShareCampaign.js";
import BreadcrumbNav from "../../../components/common/bread-crumbs/BreadCrumb.js";
import { setBreadcrumbs } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice.js";
import MyCampaignsPage from "../mycampaigns/MyCampaignsPage.js";

const BuyerDashboard = () => {
  const { user } = JSON.parse(localStorage.getItem("user") || "{}");
  const dispatch = useDispatch();
  const [campaignCid, setCampaignCid] = useState();
  const { isLoading: dashboardLoader, dashboardCampaigns } = useSelector(
    (state) => state.buyerDashboard,
  );
  const isMobile = useMediaQuery({ maxWidth: "769px" });
  const navigate = useNavigate();
  const {
    isLoading: downloadLoader,
    isPaymentsLoading,
    downloadInvoicePdf,
  } = useSelector((state) => state.buyerPayments);

  const isLoading = isPaymentsLoading || dashboardLoader || downloadLoader;

  const campaigns = [
    {
      name: "Saved Campaigns",
      count: dashboardCampaigns?.saved_campaigns,
      icon: <Image src={TotalCampaignsIcon} preview={false} />,
      value: "saved_campaign",
    },
    {
      name: "Insertion Order ",
      count: dashboardCampaigns?.insertion_order,
      icon: <Image src={InsertionOrderIcon} preview={false} />,
      value: "insertion_order",
    },
    {
      name: "Scheduled Campaigns",
      count: dashboardCampaigns?.scheduled_campaigns,
      icon: <Image src={ScheduledOrderIcon} preview={false} />,
      value: "scheduled",
    },
    {
      name: "Active Campaigns",
      count: dashboardCampaigns?.active_campaigns,
      icon: <Image src={ActiveCampaignsIcon} preview={false} />,
      value: "running",
    },
    {
      name: "Completed Campaigns",
      count: dashboardCampaigns?.completed_campaigns,
      icon: <Image src={CompletedCampaignsIcon} preview={false} />,
      value: "closed",
    },
  ];
  const [campaignId, setCampaignId] = useState();
  const [type, setType] = useState(false);
  const [shareCampaign, setShareCampaign] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);
  const [currentPage, setCurrentPage] = useState(1);
  const contentStyle = {
    height: "196px",
    color: "#fff",
    textAlign: "center",
    padding: " 28px ",
    width: "88%",
  };
  const { quotePdf } = useSelector((state) => state.sellerCampaigns);

  const downloadPdf = (type) => {
    const blob =
      type == "quote"
        ? new Blob([quotePdf], {
            type: "application/pdf",
          })
        : new Blob([downloadInvoicePdf], {
            type: "application/pdf",
          });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      type == "quote"
        ? `Quote-${campaignCid}.pdf`
        : `Payments-${campaignCid}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    setCampaignId(null);
  };
  useEffect(() => {
    if (campaignCid && (downloadInvoicePdf || quotePdf)) {
      downloadPdf(type);
    }
  }, [downloadInvoicePdf, quotePdf]);

  useEffect(() => {
    dispatch(buyerDashboardCampaignsCount());
  }, []);

  const goToSubPage = ({ title, path }) => {
    dispatch(
      setBreadcrumbs([
        { title: "Dashboard", path: `/buyer/dashboard` },
        {
          title: "Campaigns",
          path: `/buyer/mycampaigns?segment=saved_campaign`,
        },
        { title, path },
      ]),
    );
  };

  return (
    <div className="dashboard-container">
      {/* Greeting User*/}
      <div className="buyer-dashboard-content">
        {isMobile ? (
          <></>
        ) : (
          <>
            <BreadcrumbNav />
          </>
        )}

        <Row>
          <Col span={isMobile ? 24 : 21}>
            <div className="greeting-user">
              Welcome Back,{" "}
              <span className="buyer-name">
                {user?.firstName} {user?.lastName}
              </span>{" "}
              <div className="user-help-text" style={{ marginTop: "8px" }}>
                Here’s a quick overview of your recent activities and campaigns.
              </div>
            </div>
          </Col>
          <Col
            span={isMobile ? 22 : 3}
            className="help-column"
            style={{ display: "flex", gap: "20px" }}
          >
            <div>
              <Image className="help-icon" src={helpIcon} preview={false} />
            </div>
            <div className="contact-us-text">
              <div className="help-center">Help Center</div>
              <span
                className="get-help highlight-text pointer"
                onClick={() => {
                  goToSubPage({
                    title: "Contact",
                    path: `/buyer/contact`,
                  });
                  navigate(`/buyer/contact`);
                }}
              >
                {" "}
                Get Help
                <Image
                  className="arrow-icon"
                  src={slantArrowIcon}
                  preview={false}
                />
              </span>
            </div>
          </Col>
        </Row>
        <div className="scroll-container">
          {/* Campaigns Type and their count */}
          <div className="campaigns-sub-header campaigns-count">
            {" "}
            Your Campaigns ( Total {dashboardCampaigns?.total_campaigns} )
          </div>

          {!isMobile ? (
            <Row gutter={24}>
              {campaigns?.map((campaignInfo, index) => {
                return (
                  <Col style={{ width: "19.5%" }} key={index}>
                    <Card
                      className="buyer-dashboard-card"
                      onClick={() => {
                        goToSubPage({
                          title: campaignInfo?.name,
                          path: `/buyer/mycampaigns?segment=${campaignInfo?.value}`,
                        });
                        navigate(
                          `/buyer/mycampaigns?segment=${campaignInfo?.value}`,
                        );
                      }}
                    >
                      <div className="campaign-icon">{campaignInfo?.icon}</div>
                      <div className="campaign-name">{campaignInfo?.name}</div>
                      <div className="campaign-count">
                        {campaignInfo?.count ?? 0}
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            // Mobile campaign details
            <div className="carousel-container">
              <Carousel
                // effect="fade"
                className="carousel-for-campaigns"
                dots={true}
                centerMode={true} // enable center mode
                centerPadding="50px" // show 50px of prev/next slides
                slidesToShow={1}
                slidesToScroll={1}
              >
                {dashboardCampaigns &&
                  campaigns?.map((campaignInfo, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() =>
                          navigate(
                            `/buyer/mycampaigns?segment=${campaignInfo?.value}`,
                          )
                        }
                      >
                        <Card
                          style={contentStyle}
                          className="mobile-campaign-cards mobile-dashboard-icons-card"
                        >
                          <div className="campaign-icon">
                            {campaignInfo?.icon}
                          </div>
                          <div className="campaign-name">
                            {campaignInfo?.name}
                          </div>
                          <div className="campaign-count">
                            {campaignInfo?.count}
                          </div>
                        </Card>
                      </div>
                    );
                  })}
              </Carousel>
            </div>
          )}

          <div className="saved-campaign-section">
            <MyCampaignsPage isDashboard={true} />
          </div>
          {shareCampaign && (
            <ShareCampaign
              shareCampaign={shareCampaign}
              setShareCampaign={setShareCampaign}
              campaignId={campaignId}
            />
          )}
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};

export default BuyerDashboard;
